/**
 * Text Component
 */

'use client';

import styled from '@emotion/styled';
import { ReactNode } from 'react';

export type TextVariant = 'body' | 'button';
export type TextWeight = 'regular' | 'bold' | 'heavy';
export type TextSize = 'small' | 'regular' | 'large';

export interface TextProps {
  children: ReactNode;
  variant?: TextVariant;
  weight?: TextWeight;
  size?: TextSize;
  className?: string;
  style?: React.CSSProperties;
}

const StyledText = styled.span<{
  $variant: TextVariant;
  $weight: TextWeight;
  $size: TextSize;
}>`
  font-size: ${({ theme, $variant, $size }) => {
    if ($size === 'small') return '0.875rem';
    if ($size === 'large') return '1.125rem';
    return theme?.component?.text.variants[$variant].fontSize;
  }};
  line-height: ${({ theme, $variant }) => theme?.component?.text.variants[$variant].lineHeight};
  font-weight: ${({ theme, $weight }) => theme?.component?.text.weights[$weight]};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export function Text({
  children,
  variant = 'body',
  weight = 'regular',
  size = 'regular',
  className,
  style,
}: TextProps) {
  return (
    <StyledText
      $variant={variant}
      $weight={weight}
      $size={size}
      className={className}
      style={style}
    >
      {children}
    </StyledText>
  );
}

